var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEventMonitoring({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 13.5V18.375C15 19.8 15.825 21.15 17.175 21.75L18.75 22.5L20.325 21.75C21.6 21.15 22.5 19.8 22.5 18.375V13.5H15ZM21 18.375C21 19.275 20.475 20.025 19.725 20.4L18.75 20.85L17.775 20.4C17.025 20.025 16.5 19.2 16.5 18.375V15H21V18.375Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15C10.35 15 9 13.65 9 12C9 10.35 10.35 9 12 9C13.65 9 15 10.35 15 12H13.5C13.5 11.175 12.825 10.5 12 10.5C11.175 10.5 10.5 11.175 10.5 12C10.5 12.825 11.175 13.5 12 13.5V15Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.75C8.25 18.75 5.25 15.75 5.25 12C5.25 8.25 8.25 5.25 12 5.25C15.75 5.25 18.75 8.25 18.75 12H17.25C17.25 9.075 14.925 6.75 12 6.75C9.075 6.75 6.75 9.075 6.75 12C6.75 14.925 9.075 17.25 12 17.25V18.75Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.5C6.225 22.5 1.5 17.775 1.5 12C1.5 6.225 6.225 1.5 12 1.5C17.775 1.5 22.5 6.225 22.5 12H21C21 7.05 16.95 3 12 3C7.05 3 3 7.05 3 12C3 16.95 7.05 21 12 21V22.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEventMonitoring);
export default __webpack_public_path__ + "static/media/ic-event-monitoring.e85cedf354630db8ada2996d57a09c2c.svg";
export { ForwardRef as ReactComponent };